import React from "react";
import { Link } from "react-router-dom";
import { WalletContext } from "../../global/contexts";

// const teLogoNeg: string = require("../../assets/img/logo_trendespresso_neg.svg").default;
const IMG_TE_Logo_Colour: string = require("../../assets/img/TE_Logo_Colour.svg").default;
// const teLogoColoured: string = require("../../assets/img/logo_te_colour_naked.svg").default;

interface ITeMainNavigationProps {
  activeRoute: string;
}

const defaultProps: ITeMainNavigationProps = {
  activeRoute: ""
};

export function TeMainNavigation(props = defaultProps) {
  const { wallet } = React.useContext(WalletContext);

  return (
    <div className="SidebarNavigation">
      <div className="SidebarNavigation__logo">
        <a href="https://wiki.trendespresso.com" target="_blank" rel="noopener">
          {/* transition: "all 0.4s var(--transition-timing)", filter: "url(../../assets/img/logo_te_colour_naked.svg)" */}
          {/* <img src={ IMG_TE_Logo_Colour } className="te-logo-animation" style={{ width: "65px", marginBottom: "-20px", marginTop: "-20px" }} /> */}
          <img src={IMG_TE_Logo_Colour} className="te-logo-animation" style={{ width: "65px" }} />
        </a>
      </div>

      <div className="SidebarNavigation__links">
        <nav>
          <ul>
            <li>
              <Link
                className={props.activeRoute === "tradebot" ? "active" : "inactive"}
                title="Trendespresso"
                to="/"
              >
                {/* <i className="fal fa-robot"></i> */}
                <i className="fal fa-chart-mixed"></i>
              </Link>
              <span className="SidebarNavigationLabel">Trendespresso</span>
            </li>
            <li>
              {wallet.connectionState === "CONNECTED" ? (
                <Link
                  className={props.activeRoute === "swap" ? "active" : "inactive"}
                  title="Swap"
                  to="/swap"
                >
                  <i className="fal fa-arrows-repeat"></i>
                </Link>
              ) : (
                <a
                  className={`${props.activeRoute === "swap" ? "active" : "inactive"
                    } disabled`}
                  // className={props.activeRoute === "swap" ? "active" : "inactive"}
                  title="Swap"
                >
                  <i className="fal fa-arrows-repeat"></i>
                </a>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
